module.exports = ReactRedux;


//////////////////
// WEBPACK FOOTER
// external "ReactRedux"
// module id = 15
// module chunks = 0